import React, { useState } from 'react';
import { Button, Icon, Message, Popup } from 'semantic-ui-react';
import { useNoteContext } from '../context/NoteContext';
import { HelpModal } from './HelpModal';

export const FileControls: React.FC = () => {
  const { saveToFile, loadFromFile, analyses } = useNoteContext();
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [helpModalOpen, setHelpModalOpen] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      await saveToFile();
    } catch (err) {
      if (err instanceof Error && err.name !== 'AbortError') {
        setError(`Save failed: ${err.message}`);
      }
    } finally {
      setSaving(false);
    }
  };

  const handleLoad = async () => {
    setLoading(true);
    setError(null);
    try {
      await loadFromFile();
    } catch (err) {
      if (err instanceof Error && err.name !== 'AbortError') {
        setError(`Load failed: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="file-controls">
      <Popup
        content={`Save ${analyses.length} analysis${analyses.length !== 1 ? 'es' : ''} to file`}
        trigger={
          <Button
            icon
            labelPosition="left"
            onClick={handleSave}
            loading={saving}
            disabled={saving || loading}
            size="small"
          >
            <Icon name="save" />
            Save
          </Button>
        }
      />

      <Popup
        content="Load analyses from file"
        trigger={
          <Button
            icon
            labelPosition="left"
            onClick={handleLoad}
            loading={loading}
            disabled={saving || loading}
            size="small"
          >
            <Icon name="folder open" />
            Load
          </Button>
        }
      />

      <Popup
        content="Help & Documentation"
        trigger={
          <Button
            icon
            onClick={() => setHelpModalOpen(true)}
            size="small"
            className="help-button"
          >
            <Icon name="help circle" />
          </Button>
        }
      />

      {error && (
        <Message negative size="tiny" onDismiss={() => setError(null)} className="file-error">
          {error}
        </Message>
      )}

      <HelpModal open={helpModalOpen} onClose={() => setHelpModalOpen(false)} />
    </div>
  );
};
